/**
 * DVS: one-click copy for discount codes.
 * Markup: <button type="button" data-dvs-copy-code="DVS5000" data-copied-label="Kod kopyalandı">…</button>
 * plus an element with [data-dvs-copy-status] inside the same [data-dvs-copy-root] for screen-reader feedback.
 */
(() => {
  if (window.__dvsCopyCodeBound) return;
  window.__dvsCopyCodeBound = true;

  /** @param {string} text */
  const copyText = async (text) => {
    try {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(text);
        return true;
      }
    } catch (_) {
      /* fall through to the legacy path */
    }
    const field = document.createElement('textarea');
    field.value = text;
    field.setAttribute('readonly', '');
    field.style.position = 'fixed';
    field.style.opacity = '0';
    document.body.appendChild(field);
    field.select();
    let ok = false;
    try {
      ok = document.execCommand('copy');
    } catch (_) {
      ok = false;
    }
    field.remove();
    return ok;
  };

  document.addEventListener('click', async (event) => {
    const target = event.target instanceof Element ? event.target : null;
    const button = target?.closest('[data-dvs-copy-code]');
    if (!(button instanceof HTMLElement)) return;

    const code = button.dataset.dvsCopyCode || '';
    const root = button.closest('[data-dvs-copy-root]') || button.parentElement;
    const status = root?.querySelector('[data-dvs-copy-status]');
    const label = button.querySelector('[data-dvs-copy-label]') || button;
    const defaultLabel = button.dataset.defaultLabel || label.textContent;
    const copiedLabel = button.dataset.copiedLabel || 'Kod kopyalandı';
    const failedLabel = button.dataset.failedLabel || code;

    const ok = await copyText(code);
    label.textContent = ok ? `✓ ${copiedLabel}` : failedLabel;
    button.classList.toggle('is-copied', ok);
    if (status) status.textContent = ok ? copiedLabel : failedLabel;

    window.clearTimeout(Number(button.dataset.dvsResetTimer || 0));
    button.dataset.dvsResetTimer = String(
      window.setTimeout(() => {
        label.textContent = defaultLabel;
        button.classList.remove('is-copied');
        if (status) status.textContent = '';
      }, 2500)
    );
  });
})();
